import './image.scss'

export const Image = props => {
  const {height = '100px', width = '100px', onClick = () => {}, ...otherImageProps} = props
  return props?.src ? (
    <div className="image-preview" style={{height, width}}>
      <img alt="preview" width={width} height={height} className="image-preview" {...otherImageProps} />
      <div className="image-control" onClick={onClick}>
        <div className="text-light">
          <i className="fal fa-times mr-1"></i> Remove
        </div>
      </div>
    </div>
  ) : null
}
